import { useGenerator } from "@/app/context/GeneratorContext";
import JobRow from "./jobRow";
import { useEffect, useState } from "react";
// import { formatDistanceToNow } from "date-fns";

export default function JobHistory({ translations }: { translations: any }) {
  const { jobHistory, jobHistoryLoading, refetchJobHistory } = useGenerator();
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date());
  const [isRefreshDisabled, setIsRefreshDisabled] = useState(false);

  useEffect(() => {
    if (!isRefreshDisabled) return;

    const timeout = setTimeout(() => {
      setIsRefreshDisabled(false);
    }, 120000);

    return () => clearInterval(timeout);
  }, [isRefreshDisabled]);

  if (jobHistoryLoading) return <div>Loading...</div>;
  // TODO: implement error handle for query if (error) return <div>Error loading job history</div>;
  return (
    <div className="mx-auto w-full xl:w-8/12">
      <div className="w-full border-[0.5px] border-[#3C3C3C] bg-crp-grey shadow-lg sm:rounded-bl-xl sm:rounded-br-xl">
        <div className="flex items-center justify-between">
          <h2 className="mx-auto my-3 text-lg font-semibold text-white">
            {translations.lastGenerations}
          </h2>
          {/* <div className="flex items-center gap-2">
            <span className="text-sm text-gray-400">
              Updated {formatDistanceToNow(lastUpdated, { addSuffix: true })}
            </span>
            <button 
              onClick={() => {
                refetchJobHistory();
                setLastUpdated(new Date());
                setIsRefreshDisabled(true);
              }}
              disabled={isRefreshDisabled || jobHistoryLoading}
              className={`text-sm ${
                isRefreshDisabled || jobHistoryLoading
                  ? 'text-gray-500 cursor-not-allowed'
                  : 'text-blue-400 hover:text-blue-300'
              }`}
            >
              Refresh
            </button>
          </div> */}
        </div>
        <div className="-mt-2 mb-2 flex items-center justify-center text-sm text-gray-400">
          {translations.postsDisappear}
        </div>
        <div className="">
          {jobHistory?.map((job: any) => (
            <JobRow key={job.id} job={job} translations={translations} />
          ))}
        </div>
      </div>
    </div>
  );
}
